export default __webpack_public_path__ + "static/media/Persona-Structure.3e793173.svg";